module.exports = __webpack_public_path__ + "static/img/erm3.8a1f6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/erm3.png
// module id = Kzdl
// module chunks = 37